import React from 'react'

const SendIcon = props => (
  <svg width={34} height={34} fill="none" {...props}>
    <circle cx={17} cy={17} r={17} fill="#004360" />
    <path
      d="M12.94 16.4h14.365a1.73 1.73 0 00-.882-.988l-13.16-6.368a1.744 1.744 0 00-2.38 2.218L12.94 16.4zM12.94 17.563l-2.056 5.139a1.747 1.747 0 002.38 2.22l13.159-6.37a1.733 1.733 0 00.882-.99H12.94z"
      fill="#fff"
    />
  </svg>
)

export default SendIcon
